module.exports = __webpack_public_path__ + "img/juhan_wx.e440197c.jpg";